
import { set } from '@/utils/vuex'
import { getConfig } from '@/api/user'

const state = {
  loading: false,
  drawer: null,
  color: 'success',
  image: '',
  sidebarBackgroundColor: 'rgba(27, 27, 27, 0.84)',
  snackbar: {},

  protocol_dialog: false,
  protocol_item: {},
  site_dialog: false,
  site_item: {},
  protocol_site_dialog: false,
  protocol_site_item: {},
  announcement: '',
  maintainance: '',
  changePass: {}

}

const mutations = {
  loading: set('loading'),
  setDrawer: set('drawer'),
  setImage: set('image'),
  setColor: set('color'),
  snackbar: set('snackbar'),

  protocolDialog: set('protocol_dialog'),
  protocolItem: set('protocol_item'),
  siteDialog: set('site_dialog'),
  siteItem: set('site_item'),
  protocolSiteDialog: set('protocol_site_dialog'),
  protocolSiteItem: set('protocol_site_item'),

  SET_ANNOUNCEMENT: (state, announcement) => {
    state.announcement = announcement
  },
  SET_MAINTAINANCE: (state, maintainance) => {
    state.maintainance = maintainance
  },

  changePass: set('changePass')

}

const actions = {
  startLoading: (context) => {
    context.commit('loading', true)
  },
  stopLoading: (context) => {
    context.commit('loading', false)
  },
  openSnackbar: (context, payload) => {
    payload['active'] = true
    context.commit('snackbar', payload)
  },
  closeSnackbar: context => {
    context.commit('snackbar', {active: false})
  },


  // openProtocolDialog: (context, payload = {}) => {
  //   context.commit('protocolItem', payload) // THIS ORDER IS IMPORTANT!!!
  //   context.commit('protocolDialog', true) // THIS ORDER IS IMPORTANT!!!
  // },
  // closeProtocolDialog: context => {
  //   context.commit('protocolDialog', false)
  //   //context.commit('variableItem', {})
  // },
  // openSiteDialog: (context, payload = {}) => {
  //   context.commit('siteItem', payload) // THIS ORDER IS IMPORTANT!!!
  //   context.commit('siteDialog', true) // THIS ORDER IS IMPORTANT!!!
  // },
  // closeSiteDialog: context => {
  //   context.commit('siteDialog', false)
  //   //context.commit('timepointItem', {})
  // },
  // openProtocolSiteDialog: (context, payload = {}) => {
  //   context.commit('protocolSiteItem', payload) // THIS ORDER IS IMPORTANT!!!
  //   context.commit('protocolSiteDialog', true) // THIS ORDER IS IMPORTANT!!!
  // },
  // closeProtocolSiteDialog: context => {
  //   context.commit('protocolSiteDialog', false)
  //   //context.commit('timepointItem', {})
  // },

  async getConfig({ commit }) {
    const ret = await getConfig()
    commit('SET_ANNOUNCEMENT', ret.announcement)
    commit('SET_MAINTAINANCE', ret.maintainance)
  },

  openChangePassword: (context, payload) => {
    //console.log("change pass")
    payload['active'] = true
    context.commit('changePass', payload)
  },
  closeChangePassword: context => {
    context.commit('changePass', {active: false})
  },
 
}


export default {
  namespaced: true,
  state,
  mutations,
  actions
}
